
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/plumbing",
      function () {
        return require("private-next-pages/services/plumbing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/plumbing"])
      });
    }
  